module.exports = __webpack_public_path__ + "img/join_us_banner.624565f5.png";